/*
 * Copyright Mimic Networks, Inc. 2026.
 */

import { Node } from '@/client';
import { useMimicTranslation } from '@/hooks/useMimicTranslation';
import { Col } from '@/primitives/Col';
import { Flex } from '@/primitives/Flex';
import { Row } from '@/primitives/Row';
import { Text } from '@/primitives/Text';

export type ArchivedNodeBannerProps = {
  node: Node;
};

export function ArchivedNodeBanner({ node }: ArchivedNodeBannerProps) {
  const { t } = useMimicTranslation('node');

  if (!node.dateArchived) return null;

  return (
    <div style={{ marginTop: '16px' }}>
      <Row gutter={16}>
        <Col span={24}>
          <div
            style={{
              backgroundColor: '#fff7e6',
              border: '1px solid #ffd591',
              borderRadius: '6px',
              padding: '12px 16px',
            }}
          >
            <Flex align="center">
              <Text style={{ fontWeight: 500 }} data-testid="node-archive-banner">
                {t('nodeArchivedBanner', {
                  hostName: node.systemProfile?.['host.name'] || node.name,
                  dateArchived: new Date(node.dateArchived).toLocaleDateString(),
                })}
              </Text>
            </Flex>
          </div>
        </Col>
      </Row>
    </div>
  );
}
